import React, {useEffect, useState} from 'react';
import {formatAccount, formatLBP} from "../../features/ValueFormater";

const NumberInput = ({payload, setPayload, currency, objKey, defaultValuee}) => {
    const [formattedNumber, setFormattedNumber] = useState('');

    useEffect(()=>{
        if (currency!=="1" && formattedNumber){
            setFormattedNumber(formatLBP(formattedNumber?.replace(/[^\d.]/g, '')));
        }
    }, [currency]);

    useEffect(()=>{
        if (defaultValuee){
            setFormattedNumber(formatNumber(defaultValuee));
        }
    }, [defaultValuee]);

    const formatNumber = (value) => {
        // Format the number with commas and decimals
        const parts = value.split('.');
        const formattedInteger = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        return parts.length === 2 ? `${formattedInteger}.${parts[1]}` : formattedInteger;
    }

    const handleInputChange = (e) => {
        const rawValue = e.target.value;
        if (!rawValue) {
            setPayload({
                ...payload,
                [objKey]: null
            });
            setFormattedNumber(null);
            return;
        }
        // Remove non-digit and non-dot characters from the input
        const numericValue = rawValue.replace(/[^\d.]/g, '');

        // Limit the decimal value to 2 digits after the dot or no dot
        const limitedValue = numericValue !== ""
            ? currency === "1"
                ? numericValue.match(/^[0]*(\d+(?:\.\d{0,2})?)/)[1]
                : numericValue.match(/^[0]*(\d+(?:\.{0}\d{0})?)/)[1]
            : "";

        setPayload({
            ...payload,
            [objKey]: limitedValue
        });



        setFormattedNumber(formatNumber(limitedValue));
    };


    return (
        <input
            type="text"
            placeholder={(currency && currency!=0)? (currency==1? "$" : "L.L"): "Amount"}
            value={formattedNumber}
            onChange={handleInputChange}
        />
    );
};

export default NumberInput;
